import CollectionTabs from "./modules/CollectionTabs";
import ProductSteps from "./modules/ProductSteps";

new CollectionTabs();
new ProductSteps();

// window.onload = (event) => {
// };
